export interface INotificationDto<Type> {
  thisPageItems: Type[];
  thisPageIndex: number;
  totalNumber: number;
  moreAvailable: boolean;
  lastPageIndex: number;
  pageItemType: string;
}
export enum GeneralAnnouncementStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
}
export enum GeneralAnnouncementSubGroup {
  SUBMIT_REVIEW = 'SUBMIT_REVIEW',
  PRODUCT_PREVIEW = 'PRODUCT_PREVIEW',
  EVENT_SIGNUP = 'EVENT_SIGNUP',
}

export type GeneralAnnouncementDto = {
  id: string;
  htmlContent: string;
  subGroup: GeneralAnnouncementSubGroup;
  status: GeneralAnnouncementStatus;
  dateCreated: DateTimeDto;
};

export type ExpireDateDto = {
  expireDate: DateTimeDto;
};

export type UserNotificationDto = {
  id: string;
  userId: string;
  source: NotificationSource;
  status: NotificationStatus;
  priority: number;
  bestBefore?: DateTimeDto;
  type: NotificationType;
  payload:
    | AccountBillingAlertsPaymentFailed
    | AccountBillingAlertsPaymentMethodExpires
    | AccountAlertsWidgetError
    | PersonalPromotionsDiscount
    | PersonalPromotionsUpgradePlan
    | AccountSiteUpdatesCsvImport
    | ExpireDateDto;
  dateCreated: DateTimeDto;
};
export enum NotificationSource {
  PersonalAccessibilityRecommendations = 'PersonalAccessibilityRecommendations',
  AccountBillingAlerts = 'AccountBillingAlerts',
  AccountAlerts = 'AccountAlerts',
  ProjectExecutionUpdates = 'ProjectExecutionUpdates',
  PersonalPromotions = 'PersonalPromotions',
  HubSpotUpdates = 'HubSpotUpdates',
  ZendeskUpdates = ' ZendeskUpdates',
  ScannerNotifications = 'ScannerNotifications',
}
export enum NotificationStatus {
  READ = 'READ',
  NEW = 'NEW',
  DISMISS = 'DISMISS',
}
export type DateTimeDto = {
  dateTimestamp: number;
  dateReadable?: string;
};

export enum NotificationType {
  AccountBillingAlertsPaymentMethodExpires = 'AccountBillingAlertsPaymentMethodExpires',
  AccountBillingAlertsPaymentFailed = 'AccountBillingAlertsPaymentFailed',
  AccountAlertsWidgetError = 'AccountAlertsWidgetError',
  PersonalPromotionsDiscount = 'PersonalPromotionsDiscount',
  PersonalPromotionsUpgradePlan = 'PersonalPromotionsUpgradePlan',
  AccountBillingAlertsNoCardTrialExpires = 'AccountBillingAlertsNoCardTrialExpires',
}
export type AccountBillingAlertsPaymentFailed = {
  paymentLink: string;
  payAttempts: number;
  sites: AccountBillingAlertsSite[];
};
export type AccountBillingAlertsPaymentMethodExpires = {
  expireDate: DateTimeDto;
  last4: string;
  paymentMethodId: string;
};
type AccountBillingAlertsSite = {
  id: number;
  host: string;
  url: string;
  views: number;
};
export type AccountAlertsWidgetError = {
  siteId: string;
  accountCode: string;
  reason: string;
  message?: string;
};
export type PersonalPromotionsDiscount = {
  discountValue: number;
};
export enum PersonalPromotionsUpgradeType {
  TRIAL_TO_PAID_UPGRADE = 'TRIAL_TO_PAID_UPGRADE',
  MONTHLY_TO_ANNUAL_UPGRADE = 'MONTHLY_TO_ANNUAL_UPGRADE',
}
export type PersonalPromotionsUpgradePlan = {
  expiresAt: DateTimeDto;
  subscriptionId: string;
  upgradeType: PersonalPromotionsUpgradeType;
};

export type AccountSiteUpdatesCsvImport = {
  addedCount: number;
  invalidCount: number;
  duplicatedCount: number;
  usedQuota: number;
};
